import { render, staticRenderFns } from "./authorizeRole.vue?vue&type=template&id=5721313a&scoped=true&"
import script from "./authorizeRole.vue?vue&type=script&lang=js&"
export * from "./authorizeRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5721313a",
  null
  
)

export default component.exports